import React from 'react';
import { Box, Container, Heading, Text, VStack, HStack, Button, Badge } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaPlay } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';

const MotionBox = motion(Box);

const AIMasteryHero = ({ data }) => {
  return (
    <Box
      minH="90vh"
      bgGradient="linear(to-br, brand.700, brand.900, purple.600)"
      position="relative"
      overflow="hidden"
    >
      {/* Blur effects */}
      <Box
        position="absolute"
        top="15%"
        right="10%"
        w="400px"
        h="400px"
        bg="purple.400"
        opacity="0.1"
        borderRadius="full"
        filter="blur(100px)"
      />
      <Box
        position="absolute"
        bottom="10%"
        left="5%"
        w="500px"
        h="500px"
        bg="accent.green"
        opacity="0.15"
        borderRadius="full"
        filter="blur(120px)"
      />

      <Container maxW="container.xl" pt={{ base: 32, md: 40 }} pb={20}>
        <MotionBox
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <VStack spacing={6} align="center" textAlign="center">
            <Badge
              px={4}
              py={2}
              bg="purple.400"
              color="white"
              fontSize="sm"
              fontWeight="700"
              borderRadius="full"
            >
              {data.badge}
            </Badge>

            <Heading
              as="h1"
              fontSize={{ base: '3xl', md: '5xl', lg: '6xl' }}
              fontWeight="900"
              color="white"
              lineHeight="1.1"
              maxW="4xl"
            >
              {data.title}
            </Heading>

            {data.subtitle && (
              <Heading
                as="h2"
                fontSize={{ base: '2xl', md: '3xl', lg: '4xl' }}
                fontWeight="700"
                color="purple.200"
                lineHeight="1.2"
              >
                {data.subtitle}
              </Heading>
            )}

            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              color="whiteAlpha.900"
              maxW="3xl"
            >
              {data.description}
            </Text>

            <HStack spacing={4} pt={4} flexWrap="wrap" justify="center">
              <Button
                as={RouterLink}
                to={data.ctaButton.href}
                size="lg"
                bg="accent.green"
                color="white"
                px={8}
                py={7}
                fontSize="lg"
                fontWeight="700"
                rightIcon={<FaArrowRight />}
                _hover={{
                  bg: 'green.500',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 12px 40px rgba(16,185,129,0.4)',
                }}
                transition="all 0.3s"
              >
                {data.ctaButton.text}
              </Button>

              {data.secondaryButton && (
                <Button
                  as={RouterLink}
                  to={data.secondaryButton.href}
                  size="lg"
                  variant="outline"
                  borderColor="white"
                  color="white"
                  px={8}
                  py={7}
                  fontSize="lg"
                  fontWeight="700"
                  leftIcon={<FaPlay />}
                  _hover={{
                    bg: 'whiteAlpha.200',
                    transform: 'translateY(-2px)',
                  }}
                  transition="all 0.3s"
                >
                  {data.secondaryButton.text}
                </Button>
              )}
            </HStack>
          </VStack>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default AIMasteryHero;
